import { ThemeProvider } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import DefaultTheme from './Theme/DefaultTheme';
import { AppRoutes } from './Routes';
import authAPI from './API/authAPI';
import { authSlice } from './Redux';
import { closeSnackbar, SnackbarProvider } from 'notistack';
import { IconButton } from '@mui/material';
import { Clear } from '@mui/icons-material';
import StartupInfoModal from './components/StartupInfoModal/StartupInfoModal';
import { STARTUP_INFO_MODAL_DOMAINS } from './constant';

const shouldDisplayInfoModal = STARTUP_INFO_MODAL_DOMAINS.includes(window.location.hostname);

function App() {
  const dispatch = useDispatch();

  const [meDone, setMeDone] = useState(false);
  const [openStartupInfoModal, setOpenStartupInfoModal] = useState(shouldDisplayInfoModal);
  
  // Check jwt and load user to redux
  useEffect(()=>{
    authAPI.getMe()
      .then((res)=>{
        dispatch(authSlice.actions.setUser(res.data));
      })
      .catch((err)=>{
        dispatch(authSlice.actions.setUser(undefined));
        localStorage.removeItem("jwt");// clear JWT at local storage
        localStorage.removeItem("userid");// clear userid at local storage
      })
      .finally(()=>{
        setMeDone(true);
      });
  }, [dispatch]);

  return (
    <ThemeProvider theme={DefaultTheme}>
      <div className="App">
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          action={(snackbarId) => (
            <IconButton onClick={() => closeSnackbar(snackbarId)}>
              <Clear/>
            </IconButton>
          )}
        >
          {meDone && <AppRoutes />}
        </SnackbarProvider>
        <StartupInfoModal
          open={openStartupInfoModal}
          onClose={() => setOpenStartupInfoModal(false)}
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
